import { render, staticRenderFns } from "./CalendarDashboardWidget.vue?vue&type=template&id=c0cfe672&scoped=true"
import script from "./CalendarDashboardWidget.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./CalendarDashboardWidget.vue?vue&type=style&index=0&id=c0cfe672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cfe672",
  null
  
)

export default component.exports